export class LocationModel {
    id: string;
    name: string;
    locationGroupId: string;
}
